export class ValidationMessageModel {
  IsSuccess: boolean = true;
  Message: string = "";
  Params: any = {};
  constructor(isSuccess: boolean, message: string, params: any = {}) {
    this.IsSuccess = isSuccess;
    this.Message = message;
    this.Params = params;
  }
}
